import { useVariation } from "@hackler/react-sdk";

export const useCustomVariation = (experimentKey: number, defaultVariation?: string): string => {
  return useVariation(experimentKey, defaultVariation || "Z");
};
